var React = require('react');

function TriangleIcon (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M0.25 0.603553L4.64645 5L0.25 9.39645V0.603553Z","stroke":"#2F2832","strokeWidth":"0.5"}));
}

TriangleIcon.defaultProps = {"width":"5","height":"10","viewBox":"0 0 5 10","fill":"none"};

module.exports = TriangleIcon;

TriangleIcon.default = TriangleIcon;
